"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = (e = require("react")) && "object" == typeof e && "default" in e ? e.default : e,
    r = require("@chakra-ui/react");

exports.default = function (e) {
  var a = e.mode,
      o = e.wrapperProps,
      c = void 0 === o ? {} : o,
      s = e.circleProps,
      i = void 0 === s ? {} : s,
      n = e.labelProps,
      d = void 0 === n ? {} : n,
      l = e.status,
      u = void 0 !== l && l,
      b = e.label;
  return "stack" === (void 0 === a ? "inline" : a) ? t.createElement(r.Stack, Object.assign({}, c), t.createElement(r.Box, Object.assign({
    borderRadius: "full",
    w: "4",
    h: "4",
    bg: u ? "corporateGreen.500" : "corporateRed.500"
  }, i)), b && t.createElement(r.Box, Object.assign({}, d), b)) : t.createElement(r.HStack, Object.assign({}, c), t.createElement(r.Box, Object.assign({
    borderRadius: "full",
    w: "4",
    h: "4",
    bg: u ? "corporateGreen.500" : "corporateRed.500"
  }, i, {
    "data-testid": "status-indicator-test-id"
  })), b && t.createElement(r.Box, Object.assign({}, d), b));
};